import linkButtonStyles from '@github-ui/code-view-shared/css/LinkButton.module.css'
import {marketplaceActionPath} from '@github-ui/paths'
import {PlayIcon} from '@primer/octicons-react'
import {Flash, LinkButton} from '@primer/react'

import {useReposAnalytics} from '@github-ui/code-view-shared/hooks/use-repos-analytics'

import styles from './UseActionBanner.module.css'

export function UseActionBanner({actionSlug, actionId}: {actionSlug: string; actionId: number}) {
  const {sendMarketplaceActionEvent} = useReposAnalytics()
  return (
    <Flash>
      <div className={styles.Box}>
        <div className={styles.Box_1}>
          <div className={styles.Box_2}>
            <PlayIcon size="small" />
            <span className={styles.Text}>Use this GitHub action with your project</span>
          </div>
          <span className={styles.Text_1}>Add this Action to an existing workflow or create a new one</span>
        </div>
        <LinkButton
          href={marketplaceActionPath({slug: actionSlug})}
          className={linkButtonStyles.linkButton}
          onClick={() =>
            sendMarketplaceActionEvent('MARKETPLACE.ACTION.CLICK', {
              repository_action_id: actionId,

              source_url: `${window.location}`,
              location: 'files#overview',
            })
          }
          /* eslint-disable-next-line @github-ui/dotcom-primer/no-title-case -- baselined during linter rollout */
        >
          View on Marketplace
        </LinkButton>
      </div>
    </Flash>
  )
}
